


























































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { ServiceChargeBill } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';

export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class ServiceStatement extends Vue {
    public publicFunc: any = publicFunc;
    public isDisabled: boolean = true;
    public labelPosition: string = 'right';
    public month: string = '';
    public loading = false;
    public rePagin = false;
    public total = 0;
    public tableData = [];
    public timeList = [];
    public billId: string = '';
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    statusArr: any = [];
    public searchValue: any = {
        startMonth: '',
        endMonth: '',
    };
    mounted() {
        this.$refs.draggerImg.imgdrager();
        this.loadBillList();
    }
    //获取服务费月账单
    public async loadBillList() {
        this.loading = true;
        await ServiceChargeBill.GetBillList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                // let skip = this.searchPagin.skip;
                // this.tableData.map((item, index) => {
                //     item.index = skip++ + 1;
                // });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }

    public resetSearchValue() {
        this.searchValue = {
            startMonth: '',
            endMonth: '',
        };
        this.timeList = [];
        this.loadBillList();
    }
    //导出服务费月账单
    public async exportExcel() {
        let data = await ServiceChargeBill.BillListExport({ ...this.searchValue });
    }
    public datetimerange(v) {
        if (v) {
            this.searchValue.startMonth = v[0];
            this.searchValue.endMonth = v[1];
        } else {
            this.searchValue.startMonth = null;
            this.searchValue.endMonth = null;
        }
    }
    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('Invoice_page', JSON.stringify(pagin));
        this.loadBillList();
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public toSkip(row) {
        this.$router.push({
            path: '/serviceBillDetails',
            query: {
                id: row.id,
            },
        });
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.ASC = true;
        } else {
            this.searchValue.ASC = false;
        }
        switch (col.prop) {
            case 'creationTime':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
        }
        this.loadBillList();
    }
}
